// extracted by mini-css-extract-plugin
export var select = "_qn-0";